import UserInputResult from "./UserInputResult";
import { percentagePointsReached } from './calculatePoints'

export default class MultipleChoiceValidator
{
    //userInput is an array with one element:
    // {
    //    key: results,
    //    value: [{
    //        image: currentImage.image,
    //        expectedInput: currentImage.group,
    //        userInput: this.currentUserInput
    //    },...]
    //}
    static isAnswerCorrect(answer)
    {
        const question = answer.question()
        const userInput = answer.userInput()[0]
        const userInputResult = new UserInputResult()

        userInputResult.resetResultStructureWith(userInput ? userInput.value: null)

        return percentagePointsReached(userInputResult, question) >= 75
    }
}

